import { cn } from '../lib/cn.js'

/** Bloco cinza pulsante para o estado de carregamento. */
export function Esqueleto({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-gray-200', className)} aria-hidden />
}
